import { useTranslation } from 'next-i18next';
import Link from 'next/link';

export const closeMenu = () => {
  const toggleInput: any = document.querySelector('input.toggle');
  if (toggleInput) {
    toggleInput.checked = false;
  }
};

const NavLink = ({ route }) => {
  const { t } = useTranslation();

  return (
    <Link
      onClick={() => closeMenu()}
      className="nav-link text-white font-weight-bold text-size-md d-flex"
      href={route.path}
    >
      <div className="d-inline route-name">
        {t(`navigations.${route.name}`)}
      </div>
    </Link>
  )
}

export default NavLink;
